import { staticContentAxios } from '../../configuration/axiosConfig';
import { ClientResponse } from '../../../model/ClientResponse';

// eslint-disable-next-line import/prefer-default-export
export const getYearList = async (): Promise<ClientResponse<string[]>> => {
  const { data, status } = await staticContentAxios.get('static/SK/ZZ/list.json');

  let mappedData: string[];
  if (data === null) {
    mappedData = [];
  } else {
    mappedData = data.rok;
  }

  return {
    data: mappedData,
    responseCode: status,
  };
};
